import { render, staticRenderFns } from "./GoodsReceivedNoteItems.vue?vue&type=template&id=08ee5c7a"
import script from "./GoodsReceivedNoteItems.vue?vue&type=script&lang=js"
export * from "./GoodsReceivedNoteItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports